import React, { Component } from "react"

class AmendHeaderSection extends Component {
  render() {
    const { title, description, manageBookingResult } = this.props
    if (!manageBookingResult) return null
    const { booking } = manageBookingResult
    if (!booking) return ""
    return (
      <section className="deck deck--white deck--padding-top deck--padding-bottom-short">
        <div className="w--wider">
          <header className="article__header article__header--centercontent">
            <h1>{title}</h1>
            <p>
              {description} {booking.reference}
            </p>
          </header>
        </div>
      </section>
    )
  }
}
export default AmendHeaderSection
